export const WhatsappIcon = (props) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.855 5.052A10.328 10.328 0 0012.495 2C6.758 2 2.09 6.669 2.09 12.406c0 1.833.478 3.624 1.388 5.203L2 23l5.517-1.448c1.519.83 3.23 1.265 4.974 1.265h.004C18.228 22.817 23 18.148 23 12.411c0-2.78-1.181-5.39-3.145-7.36zm-7.36 16.012A8.634 8.634 0 018.09 19.86l-.314-.187-3.272.858.872-3.193-.206-.328a8.62 8.62 0 01-1.322-4.603c0-4.767 3.881-8.648 8.653-8.648 2.31 0 4.481.9 6.113 2.536 1.63 1.636 2.634 3.806 2.63 6.117 0 4.772-3.98 8.653-8.748 8.653zm4.744-6.478c-.258-.131-1.537-.76-1.777-.844-.239-.089-.412-.131-.585.131-.174.263-.67.844-.825 1.022-.15.174-.305.197-.563.066-1.528-.764-2.531-1.364-3.539-3.094-.267-.46.267-.426.764-1.42.084-.174.042-.324-.023-.455-.066-.131-.586-1.41-.802-1.931-.21-.506-.426-.436-.586-.445-.15-.01-.323-.01-.497-.01a.963.963 0 00-.693.324c-.24.262-.91.89-.91 2.17 0 1.28.933 2.517 1.06 2.69.13.174 1.832 2.8 4.443 3.929 1.65.712 2.297.773 3.122.651.502-.075 1.538-.628 1.753-1.237.216-.61.216-1.13.15-1.238-.06-.117-.234-.182-.492-.31z"
      fill="inherit"
    />
  </svg>
);

export const FacebookIcon = (props) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"
      fill="inherit"
    />
  </svg>
);

export const TwitterIcon = (props) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.267 5.665A4.9 4.9 0 0010.4 8.36l.001.001c-.531-.073-.815-.063-1.973-.538-1.74-.714-3.457-2.06-5.15-4.037C-.329 12.47 5.16 15.7 6.539 16.61c-1.63 1.193-4.45 1.496-5.144 1.55 1.362 1.422 6.114 2.493 9.382 1.841 4.766-.95 9.463-4.667 9.463-12.309.714-.979.879-1.69 1.214-3.33-1.353.82-1.958.64-2.669.644a4.9 4.9 0 00-7.518.66z"
      fill="inherit"
    />
  </svg>
);

export const LinkedinIcon = (props) => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.94 5a2 2 0 11-4-.002 2 2 0 014 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z"
      fill="inherit"
    />
  </svg>
);
